import { render } from "./scales.vue?vue&type=template&id=8a7b0528"
import script from "./scales.vue?vue&type=script&lang=js"
export * from "./scales.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__